/**
 * @deprecated Use <div className="flex"> instead
 */
import styled from 'styled-components'
import { Box } from './Box'

export { Box } from './Box'

export const Flex = styled(Box)`
  display: flex;
`
